// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "" + "4cb8a6cc6b9a694b8a24" + ".js";
};